export default "__VITE_ASSET__dd40e0ae__"